import { IconMoon, IconSun } from "@tabler/icons-react";
import { useContext } from "react";
import { ThemeContext, ToggleThemeContext } from "@common/context/ThemeContext";
import { __ } from "@common/helpers/i18n";

export default function HeaderThemeToggle() {
  const theme = useContext(ThemeContext);
  const toggleTheme = useContext(ToggleThemeContext);
  const isDark = theme === "dark";
  const Icon = isDark ? IconSun : IconMoon;

  return (
    <button
      type="button"
      title={isDark ? __("Light mode") : __("Dark mode")}
      aria-label={
        isDark ? __("Switch to light mode") : __("Switch to dark mode")
      }
      onClick={toggleTheme}
      onMouseUp={(event) => event.currentTarget.blur()}
      onTouchEnd={(event) => event.currentTarget.blur()}
      className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-transparent text-foreground transition-colors duration-150 hover:border-border hover:bg-muted focus:outline-none focus:ring-0 focus-visible:border-primary/30 focus-visible:bg-primary/5"
    >
      <Icon size={21} stroke={2} />
    </button>
  );
}
